(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mailing-popup"]) return;
  try {
    
class MailingPopup extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    if (!window.Shopify?.designMode) {
      this.scheduleShow();
    }
  }

  scheduleShow() {
    const enabled = JSON.parse(this.dataset.enabled || 'false');
    if (!enabled) return;

    const delay = parseInt(this.dataset.delay, 10) || 5;
    const frequency = parseInt(this.dataset.frequency, 10) || 7;
    const storageKey = 'popup_shown_' + this.dataset.popupId;
    const lastShown = localStorage.getItem(storageKey);

    if (lastShown) {
      const daysSince = (Date.now() - parseInt(lastShown, 10)) / 864e5;
      if (daysSince < frequency) return;
    }

    this.timer = setTimeout(() => {
      window.theme?.publish?.('modalToggle', { id: this.dataset.popupId });
      localStorage.setItem(storageKey, Date.now().toString());
    }, delay * 1000);
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }
}

if (!customElements.get('mailing-popup')) {
  customElements.define('mailing-popup', MailingPopup);
}

  } catch(e) { console.error(e); }
})();
})();
